import { DeliveryCategory, Label } from '~api/api';

import { useTranslate } from '~src/main/context/localization';
import { useFormatPriceFn } from '~src/main/price/price';
import { priceToString } from '~src/main/price/price-range';

export function useFreeShippingLabels(category: DeliveryCategory): Label[] {
  const tICU = useTranslate();
  const formatFn = useFormatPriceFn();
  
  const totalValue = category.default_prices.reduce((minValue, price) => {
    return Math.min(minValue, price.free_shipping?.minimum_total_value ?? Infinity);
  }, Infinity);

  if (totalValue === Infinity) {
    return [];
  }

  const labelText = tICU('fsi.total_value', {
    total_value: formatFn(priceToString(totalValue)),
  });

  return [{ name: labelText }];
}
